import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAvSlugClick } from '../context/AvSlugClickContext';
import type { AvSelectionCandidate } from '../types/epi-chat-types';

interface VariableMatchViewDetailsButtonProps {
  candidate: AvSelectionCandidate;
}

/** Opens the variable's detail record; absent when the host wires no handler. */
export const VariableMatchViewDetailsButton = ({
  candidate,
}: VariableMatchViewDetailsButtonProps) => {
  const { formatMessage } = useIntl();
  const avSlugClick = useAvSlugClick();
  if (!avSlugClick) return null;

  return (
    <Button
      variant="text"
      size="small"
      onClick={(event) => {
        // The button sits inside a selectable option; opening details must not select it.
        event.stopPropagation();
        avSlugClick(candidate.analyticalVariableId);
      }}
      aria-label={`View details of ${candidate.dataElement}`}
      sx={{ textTransform: 'none' }}
    >
      {formatMessage({ id: 'epiChat.variableMatch.viewDetails', defaultMessage: 'View details' })}
    </Button>
  );
};
